import React from "react";

function BptpDispo() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <g transform="translate(-1065.000000, -399.000000) translate(1065.000000, 293.000000) translate(0.000000, 48.000000) translate(0.000000, 58.000000)">
                                <rect width="42" height="42" fill="#CCC" opacity=".376" rx="4" />
                                <g>
                                    <g fill="#999" fillRule="nonzero">
                                        <path
                                            d="M28.8 0H3.6v3.6H0v15.6h25.2v-3.6h3.6V0zM24 18H1.2V4.8H24V18zm3.6-3.6h-2.4V3.6H4.8V1.2h22.8v13.2z"
                                            transform="translate(6.000000, 11.000000)"
                                        />
                                        <path
                                            d="M12.6 15.6c2.32 0 4.2-1.88 4.2-4.2 0-2.32-1.88-4.2-4.2-4.2-2.32 0-4.2 1.88-4.2 4.2 0 2.32 1.88 4.2 4.2 4.2zm0-7.2c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
                                            transform="translate(6.000000, 11.000000)"
                                        />
                                    </g>
                                    <g>
                                        <path fill="#FFF" d="M5 3H12V11H5z" transform="translate(6.000000, 11.000000) translate(20.000000, 11.000000)" />
                                        <path
                                            fill="#999"
                                            fillRule="nonzero"
                                            d="M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm2.475 8.237c.341.342.341.896 0 1.238-.342.341-.896.341-1.238 0L7 8.237 5.763 9.475c-.342.341-.896.341-1.238 0-.341-.342-.341-.896 0-1.238L5.763 7 4.525 5.763c-.341-.342-.341-.896 0-1.238.342-.341.896-.341 1.238 0L7 5.763l1.237-1.238c.342-.341.896-.341 1.238 0 .341.342.341.896 0 1.238L8.237 7l1.238 1.237z"
                                            transform="translate(6.000000, 11.000000) translate(20.000000, 11.000000)"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default BptpDispo;
